import useTypedFlags from "hooks/useTypedFlags";
import { isSelfHostedDistribution } from "utils/distribution";
import { isProductionFedRampEnvironment } from "utils/env";

const useIntentProjectAccess = () => {
  const isSelfHosted = isSelfHostedDistribution();
  const isProductionFedRamp = isProductionFedRampEnvironment();

  const { squirrelIntentProject } = useTypedFlags();

  return squirrelIntentProject && !isSelfHosted && !isProductionFedRamp;
};

export default useIntentProjectAccess;
